import React from "react";
import { ProductoEspecificoSelecion } from "../components/PagesProducto/PaginaEspecificaProductoSelecionado";
import { Container } from "@mui/material";


export const PaginaEspecificaProducto = () =>{

    return(
        <Container maxWidth="lg" sx={{
            marginTop:'150px',
            marginBottom:'100px',
               '@media (max-width:600px)': {
        marginTop:'60px'
    }, 
        }}>
         <h1 style={{color:'transparent', position:'absolute', width:'80px', fontSize:'1px'}}> cotizar vending, presupuesto máquinas expendedoras, asesoría vending, cotización automática, soluciones vending, catálogo Jofemar Chile, empresa de vending Chile, historia HOD, vending sostenible, equipo HOD, tecnología vending, Jofemar Chile, máquinas vending Chile, soluciones automatizadas, vending para empresas, vending inteligente, distribución automática, Jofemar Chile, máquinas vending Chile, soluciones automatizadas, vending para empresas, vending inteligente, distribución automática, Jofemar Chile, servicio técnico vending, instalación máquinas vending, mantenimiento vending, soporte postventa, asistencia vending, repuestos Jofemar</h1>
        <ProductoEspecificoSelecion/>
        </Container>
    )
}